export default "__VITE_ASSET__CfMaU1Iw__"